import type { ProductConfigDefinition } from 'Models/uiConfig/productConfig.types';

export default {
  fields: {
    id: 'product_id',
    image: 'thumbnail',
    title: 'name',
    url: 'url',
  },
  getItemId: (): string | undefined =>
    window.cm_product?.[0] ??
    window.document.querySelector<HTMLInputElement>('button[name="add-to-cart"]')?.value,
  getVariantId: (): undefined => undefined,
} satisfies ProductConfigDefinition;
